export default __webpack_public_path__ + "static/media/timeIndicator.63009b96.svg";